import axiosVerbose from './axios/axiosVerbose'
import { logError } from './errors'

const legacyAffiliates = (location) => {
  axiosVerbose.get(`/shopfront_api/affiliate/legacy?location=${escape(location.href)}`)
    .then(res => {
      if (res.data && res.data.redirect) {
        window.location = res.data.redirect_url
      }
    })
    .catch(logError)
}

export default legacyAffiliates



// WEBPACK FOOTER //
// ./common/utils/legacyAffiliates.js